// src/translations/footer.js
export default {
  en: {
    company_description: "Hi, I'm a real estate professional dedicated to helping you find your perfect home, sell your property, or invest in buildable land. I offer personalized service, market expertise, and transparent communication to make your real estate journey smooth and successful.",
    business_registration: "Download Chamber of Commerce Registration",
    navigate: "Navigate",
    nav_home: "Home",
    nav_about: "About",
    nav_contact: "Contact",
    language: "Language",
    all_rights_reserved: "All rights reserved.",
    get_in_touch: "Get in touch",
    legal: "Legal",
    privacy_policy: "Privacy Policy",
    cookie_policy: "Cookie Policy",
    terms_conditions: "Terms and Conditions"
  },
  it: {
    company_description: "Ciao, sono una professionista immobiliare dedicata ad aiutarti a trovare la casa perfetta, vendere la tua proprietà o investire in terreni edificabili. Offro un servizio personalizzato, competenze di mercato e comunicazione trasparente per rendere il tuo percorso immobiliare fluido e di successo.",
    business_registration: "Scarica Visura Camera di Commercio",
    navigate: "Naviga",
    nav_home: "Home",
    nav_about: "Chi Sono",
    nav_contact: "Contattami",
    language: "Lingua",
    all_rights_reserved: "Tutti i diritti riservati.",
    get_in_touch: "Contatti",
    legal: "Legal",
    privacy_policy: "Privacy Policy",
    cookie_policy: "Cookie Policy",
    terms_conditions: "Termini e Condizioni",
  }
};